<template>
    <div class="d-flex flex-column flex-lg-row h-lg-90px rounded overflow-hidden gap-1">
        <!-- Order received info -->
        <transition name="slide-fade">
            <TileOrderConfirmed :order="order"
                                @transition="toState => transitionTo(toState)"/>
        </transition>

        <!-- Prepared (Click & Collect / Reservation) -->
        <transition name="slide-fade">
            <TileOrderPrepared
                v-if="!isDelivery && logsByState.hasOwnProperty(OrderState.Confirmed) || isDelivery && logsByState.hasOwnProperty(OrderState.ReadyForPickup)"
                :order="order"
                :users="users"
                @transition="toState => transitionTo(toState)"/>
        </transition>

        <!-- Send/Pickup (Delivery) -->
        <transition name="slide-fade">
            <div v-if="isDelivery && logsByState.hasOwnProperty(OrderState.Confirmed)">
                <TileOrderSendShippingProvider :store="store"
                                               :order="order"
                                               :users="users"
                                               :shipping-providers="shippingProviders"
                                               @transition="toState => transitionTo(toState)"
                />
            </div>
        </transition>

        <!-- Delivered -->
        <transition name="slide-fade">
            <div v-if="isDelivery && logsByState.hasOwnProperty(OrderState.Delivered)">
                <TileOrderDelivered :store="store"
                                    :order="order"
                                    :users="users"
                />
            </div>
        </transition>

        <!-- Order picked up by customer -->
        <transition name="slide-fade">
            <TileOrderPickedUp
                v-if="!isDelivery && (order.state === OrderState.ReadyForPickup || logsByState.hasOwnProperty(OrderState.PickedUp))"
                :store="store"
                :order="order"
                :users="users"
                @transition="toState => transitionTo(toState)"/>
        </transition>

        <!-- Order cancelled -->
        <transition name="slide-fade">
            <TileOrderCancelled v-if="logsByState.hasOwnProperty(OrderState.Cancelled)"
                                :users="users"/>
        </transition>

        <!-- Order refunded -->
        <transition name="slide-fade">
            <TileOrderRefunded v-if="logsByState.hasOwnProperty(OrderState.Refunded)"
                               :users="users"/>
        </transition>

        <!-- Order rejected -->
        <transition name="slide-fade">
            <TileOrderRejected v-if="logsByState.hasOwnProperty(OrderState.Rejected)"
                               :users="users"/>

            <!-- TODO: refund youbuyda? -->
        </transition>

        <!-- Reject/Refund buttons -->
        <transition name="slide-fade">
            <CancelRejectRefund :store="store"
                                :order="order"
                                @transition="toState => transitionTo(toState)"/>
        </transition>
    </div>
</template>

<script>
import { Link } from '@inertiajs/vue2';
import AddShippingDetailsModal from '@components/Orders/Modals/AddShippingDetailsModal.vue';
import TileOrderPrepared from '@components/Orders/Timeline/Tiles/TileOrderPrepared.vue';
import TileOrderPickedUp from '@components/Orders/Timeline/Tiles/TileOrderPickedUp.vue';
import TileOrderCancelled from '@components/Orders/Timeline/Tiles/TileOrderCancelled.vue';
import TileOrderRefunded from '@components/Orders/Timeline/Tiles/TileOrderRefunded.vue';
import {OrderState} from '@composables/orderStates';
import TileOrderRejected from '@components/Orders/Timeline/Tiles/TileOrderRejected.vue';
import CancelRejectRefund from '@components/Orders/Timeline/Tiles/CancelRejectRefund.vue';
import OrderTimelineBox from "@components/Orders/Timeline/OrderTimelineBox.vue";
import TileOrderConfirmed from "@components/Orders/Timeline/Tiles/TileOrderConfirmed.vue";
import TileOrderSendShippingProvider from "@components/Orders/Timeline/Tiles/TileOrderSendShippingProvider.vue";
import TileOrderDelivered from "@components/Orders/Timeline/Tiles/TileOrderDelivered.vue";

export default {
    components: {
        TileOrderDelivered,
        TileOrderSendShippingProvider,
        CancelRejectRefund,
        TileOrderRejected,
        TileOrderRefunded,
        TileOrderCancelled,
        TileOrderPickedUp,
        TileOrderPrepared,
        TileOrderConfirmed,
        AddShippingDetailsModal,
        OrderTimelineBox,
        Link,
    },

    props: {
        order: Object,
        store: Object,
        shippingProviders: Array,
        users: Object,
    },

    data() {
        return {
            loading: false,
            showAddShippingDetails: false,
            spinners: {
                prepareOrder: false,
                fulfill: false,
            },
        };
    },

    methods: {
        transitionTo(newState) {
            this.loading = true;

            if (newState === OrderState.ReadyForPickup) {
                this.spinners.prepareOrder = true;
            }

            if (newState === OrderState.Send || newState === OrderState.PickedUp) {
                this.spinners.fulfill = true;
            }

            this.$inertia.visit(this.$route('order.state', [this.store.id, this.order.url_key]), {
                data: {
                    to_state: newState,
                },
                method: 'PATCH',
                only: ['order', 'logsByState', 'users'],
                // preserveState: true,
            });
        },
    },

    computed: {
        logsByState() {
            return this.order.logs_by_state;
        },

        OrderState() {
            return OrderState;
        },

        wasRefunded() {
            return this.logsByState.hasOwnProperty(OrderState.Refunded);
        },

        isWaitingForIntegration() {
            if (this.loading) {
                return true;
            }

            return this.order.state === OrderState.WaitForIntegration;
        },

        isDelivery() {
            return this.order.type === 'delivery';
        },

        isRefunded() {
            return this.logsByState.hasOwnProperty(OrderState.Refunded);
        },
    },
};
</script>

<style>
button[disabled] {
    cursor: not-allowed !important;
}

.slide-fade-enter-active,
.slide-fade-leave-active {
    transition: 0.24s cubic-bezier(0.25, 1, 0.5, 1);
}

.slide-fade-enter-from,
.slide-fade-leave-to {
    transform: translateX(10px);
    opacity: 0;
}
</style>
